import { render, staticRenderFns } from "./ContainerOutbound.vue?vue&type=template&id=8251f560"
import script from "./ContainerOutbound.vue?vue&type=script&lang=js"
export * from "./ContainerOutbound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports